export default defineNuxtPlugin(() => {
    const route = useRoute()
    const checkoutStore = useCheckoutStore()

    const affiliateCode = route.query.affiliateCode as string | undefined
    const sPartner = route.query.sPartner as string | undefined

    if (affiliateCode) {
        checkoutStore.orderAffiliateCode = affiliateCode
        localStorage.setItem('affiliateCode', affiliateCode)
    } else {
        const stored = localStorage.getItem('affiliateCode')
        if (stored && !checkoutStore.orderAffiliateCode) {
            checkoutStore.orderAffiliateCode = stored
        }
    }

    if (sPartner) {
        checkoutStore.orderCampaignCode = sPartner
        localStorage.setItem('campaignCode', sPartner)
    } else {
        const stored = localStorage.getItem('campaignCode')
        if (stored && !checkoutStore.orderCampaignCode) {
            checkoutStore.orderCampaignCode = stored
        }
    }
})
